module.exports = __webpack_public_path__ + "static/media/galerija_2022_0036.a2e147c1.jpg";